import { connect } from "react-redux"
import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhone, faEnvelope } from "@fortawesome/pro-regular-svg-icons"
import { faCalendarDay } from "@fortawesome/pro-regular-svg-icons/faCalendarDay"
import { formatDate, formatTime } from "../../helpers/dateHelpers"
import * as phoneNumberHelpers from "../../helpers/phoneNumberHelpers"
import { Button } from "semantic-ui-react"
import { faPrint } from "@fortawesome/free-solid-svg-icons"

const InstallDetails = ({ dispatch, match }) => {
  const [order, setOrder] = useState(null)
  useEffect(() => {
    dispatch({
      type: "TIRE_ORDER_DETAILS_SAGA",
      payload: match.params.id,
      callback: (res, data) => {
        if (data?.fleet_tire_shop_order) {
          setOrder(data.fleet_tire_shop_order)
        }
      }
    })
  }, [])

  const customer = order?.user

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex justify-end mt-5 print:!hidden">
        <Button className="!flex gap-2" onClick={() => window.print()}>
          <FontAwesomeIcon icon={faPrint} />
          Print
        </Button>
      </div>
      <div className="bg-white max-w-4xl mx-auto my-5 border print:border-none font-catamaran">
        <div className="p-10">
          <div className="flex items-start justify-between flex-col md:flex-row print:flex-row gap-10">
            <div className="w-full md:max-w-[50%] print:max-w-[50%]">
              <p className="text-2xl md:text-4xl print:text-4xl font-bold !text-black mb-0 text-center md:!text-left print:!text-left">
                Tire Install:
              </p>
              <p className="text-2xl md:text-4xl print:text-4xl font-bold !text-black mb-0 text-center md:!text-left print:!text-left">
                Appointment Details
              </p>
            </div>
            <div style={{ flex: "1 1 0px" }} className="w-full">
              <p className="!mb-[5px] text-2xl font-semibold">{order?.shop?.name}</p>
              <div className="flex justify-between flex-col w-full">
                <div>
                  <p className="!mb-[5px] text-xl">{order?.shop?.address_line1}</p>
                  <p className="!mb-[5px] text-xl">
                    {order?.shop?.city}, {order?.shop?.state} {order?.shop?.zip}
                  </p>
                </div>
                <div>
                  {order?.shop?.main_phone_number && (
                    <p className="!mb-[5px] text-xl">
                      <FontAwesomeIcon icon={faPhone} className="mr-1" />
                      {phoneNumberHelpers.reformat(order.shop.main_phone_number)}
                    </p>
                  )}
                  <p className="mb-0 text-xl">
                    <FontAwesomeIcon icon={faCalendarDay} />{" "}
                    {formatDate(order?.appointment_datetime_in_iso)} |{" "}
                    {formatTime(order?.appointment_datetime_in_iso)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr className="my-5" style={{ color: "#D7D7D7" }} />

          <div className="flex gap-5 justify-between flex-col flex-col-reverse md:flex-row print:flex-row reversed">
            <div className="instructions max-w-full md:max-w-1/2 print:max-w-1/2">
              <p className="font-bold text-2xl">Your Instructions</p>
              <div className="flex gap-3 mb-5">
                <p className="bg-gray-200 px-3 py-1 self-start rounded-full font-bold">1</p>
                <div>
                  <p className="mb-0 text-xl">
                    <strong>Tell the shop you have an appointment:</strong>
                  </p>
                  <p className="text-xl">
                    Let the shop know you're there for a tire install booked through CarAdvise. The
                    appointment may be under your name or someone else's, depending on who placed
                    the order. Tire and appointment details are listed on this page.
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <p className="bg-gray-200 px-3 py-1 self-start rounded-full font-bold">2</p>
                <p className="text-xl">
                  <strong>No payment needed:</strong> You do not need to pay at the shop. The work
                  will be reviewed and approved through CarAdvise - either automatically or by your
                  fleet's designated approvee. Once approved, the shop can complete the
                  installation.
                </p>
              </div>

              <p className="font-bold text-2xl pt-5">Shop Instructions</p>
              <div className="flex gap-3 mb-5">
                <p className="bg-gray-200 px-3 py-1 self-start rounded-full font-bold">1</p>
                <div>
                  <p className="mb-0 text-xl">
                    <strong>Confirm tires on site:</strong>
                  </p>
                  <p className="text-xl">
                    Tires should arrive labeled with the name listed under "Customer Information".
                    All tire, customer, and appointment details are listed on this page for
                    reference
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <p className="bg-gray-200 px-3 py-1 self-start rounded-full font-bold">2</p>
                <p className="text-xl">
                  <strong>Submit through Auto Integrate: </strong>
                  Include the tire install and any recommended services in your Auto Integrate
                  submission. Approval will be provided shortly after submission to begin work.
                </p>
              </div>
            </div>

            <hr className="!h-auto" style={{ border: "0.5px solid #D7D7D7", opacity: "0.5" }} />

            <div className="flex flex-col gap-5" style={{ flex: "1 1 0px" }}>
              <div className="flex flex-col justify-between">
                <div className="w-full">
                  <p className="font-bold text-xl md:text-2xl print:text-2xl m-0 pb-2">
                    Tire Details
                  </p>
                </div>
                <div className="flex-1">
                  <p className="text-xl m-0 pb-1">
                    {order?.tire_orders[0]?.brand} {order?.tire_orders[0]?.model}
                  </p>
                  <p className="text-xl m-0 pb-1">{order?.tire_orders[0]?.tire_details}</p>
                  <p className="text-xl m-0 pb-1">Quantity: {order?.tire_orders[0]?.quantity}</p>
                </div>
              </div>

              <div className="flex flex-col justify-between">
                <div className="w-full">
                  <p className="font-bold text-xl md:text-2xl print:text-2xl m-0 pb-2">
                    Customer Information
                  </p>
                </div>
                <div className="flex-1">
                  <p className="text-xl m-0 pb-1">{customer?.name}</p>
                  <p className="text-xl m-0 pb-1">
                    {phoneNumberHelpers.reformat(customer?.phone_number)}
                  </p>
                  <p className="text-xl m-0 pb-1">{customer?.email}</p>
                </div>
              </div>

              <div className="flex flex-col justify-between">
                <div className="w-full">
                  <p className="font-bold text-xl md:text-2xl print:text-2xl m-0 pb-2">
                    Auto Integrate Processing Details
                  </p>
                </div>
                <div className="flex-1">
                  <p className="text-xl m-0 pb-1">CarAdvise National Fleet Account</p>
                  <p className="text-xl m-0 pb-1">
                    {order?.vehicle?.year} {order?.vehicle?.make} {order?.vehicle?.model}
                  </p>
                  <p className="text-xl m-0 pb-1">VIN: {order?.vehicle?.vin}</p>
                </div>
              </div>

              <div className="hidden md:block print:block">
                <p className="font-bold text-2xl m-0">Need assistance?</p>
                <p className="text-xl m-0 pb-2">Our support team is here to help!</p>
                <p className="text-xl m-0 pb-1">
                  <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> support@caradvise.com
                </p>
                <p className="text-xl m-0">
                  <FontAwesomeIcon icon={faPhone} className="mr-1" /> (844) 923-8473
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2 print:w-1/2 mt-10 md:mt-5 print:mt-5">
            <p className="bg-gray-200 font-bold px-2 py-1 rounded-xl block !mx-auto w-fit">
              Order ID: {order?.id}
            </p>
            <div className="text-center mt-10 md:hidden print:hidden">
              <p className="font-bold text-2xl m-0">Need assistance?</p>
              <p className="text-xl m-0 pb-2">Our support team is here to help!</p>
              <p className="text-xl m-0 pb-1">
                <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> support@caradvise.com
              </p>
              <p className="text-xl m-0">
                <FontAwesomeIcon icon={faPhone} className="mr-1" /> (844) 923-8473
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps)(InstallDetails)
